import { CardBody, Collapse } from "reactstrap";
import { H4, Image } from "../../../../../AbstractElements";
import { dynamicImage } from "../../../../../Service/DynamicImage";
import { MyProfileClassCollapseProp } from "../../../../../Type/SocialAppType";
import MessagesAndNotification from "./MessagesAndNotification";
import LikesViewButton from "./LikesViewButton";
import SocialGroup from "./SocialGroup";

const MyProfileClassCollapse = ({ isFilter }: MyProfileClassCollapseProp) => {
  return (
    <Collapse isOpen={isFilter}>
      <CardBody className="socialprofile filter-cards-view">
        <div className="d-flex">
          <Image className="img-50 img-fluid m-r-20 rounded-circle" src={dynamicImage("user/1.jpg")} alt="user" />
          <MessagesAndNotification />
        </div>
        <LikesViewButton />
        <div className="likes-profile text-center">
          <H4>
            <span><i className="fa fa-heart font-danger"/> 884</span></H4>
        </div>
        <div className="text-center">35 New Likes This Week</div>
        <div className="customers text-center social-group">
          <SocialGroup />
        </div>
        <Image className="img-fluid mt-5" alt="" src={dynamicImage("social-app/timeline-3.png")} />                            
      </CardBody>
    </Collapse>
  );
};

export default MyProfileClassCollapse;
